import { useEffect, useState } from 'react';

/**
 * Returns a debounced copy of `value` that only updates after `delay` ms of no
 * changes. Compares by serialized content so unstable object identities (e.g.
 * Formik `values`) do not reset the timer on every render.
 */
export const useDebouncedValue = <T>(value: T, delay = 500): T => {
  const [debounced, setDebounced] = useState(value);
  const serialized = JSON.stringify(value);

  useEffect(() => {
    const timeout = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(timeout);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [serialized, delay]);

  return debounced;
};
